<script setup>
import { ref, shallowRef, provide, watch } from 'vue';
import ImageViewer from '@/components/iiif/ImageViewer.vue'
import ThumbnailCarousel from '@/components/carousel/index.vue'
import IconButton from '@/components/buttons/IconButton.vue'
import IconChevron from '@/components/icons/IconChevron.vue'
import Coachmark from '@/components/coachmark/Coachmark.vue'

import useInteraction from '@/composables/interaction'

const componentKey = ref(0)
const menuOpen = ref(false)


const canvasIndex = ref(0)
const updateCanvasIndex = (newIndex) => {
  canvasIndex.value = newIndex
}

provide('canvasIndex', {
  canvasIndex,
  updateCanvasIndex
})

watch(canvasIndex, () => {
  useInteraction('full_canvas_view', {
    canvas: canvasIndex.value
  })
})


const thumbnails = shallowRef([])

const setThumbnails = (tbs) => {
  thumbnails.value = tbs
}

const addThumbnails = (tbs) => {
  thumbnails.value = thumbnails.value.concat(tbs)
}

provide('thumbnails', {
  thumbnails,
  setThumbnails,
  addThumbnails
})

// Coachmark
// const showMark = ref(true)
</script>

<template>
  <div id="full-album" class="grid max-h-full overflow-hidden menu-open">
    <ImageViewer
      :overlay-controls="true"
      :canvas-index="canvasIndex"
      :component-key="componentKey"
      thumbnails
      class="h-full w-screen"
    >
      <!-- <template #menuControls>
        <Coachmark :message="$t('coachmarks.full_tour_menu_toggle')" :active="showMark" :alignment="'right-center'" @close="showMark = false">
          <IconButton @click="menuOpen = !menuOpen">
            <IconChevron :class="{ 'closed-menu': !menuOpen }" class="w-25 h-25 rotate-90 transition-transform ease-in-out duration-300"/>
          </IconButton>
        </Coachmark>
      </template> -->
    </ImageViewer>
    <ThumbnailCarousel class="border-t-2 border-cream" />
  </div>
</template>

<style>
#full-album {
  display: grid;
  height: calc(100vh - 60px);
  overflow-y: hidden;
  grid-template-rows: auto 220px;
  transition: 300ms linear;
}

#full-album.menu-open {
  grid-template-rows: auto 220px;
}

.closed-menu {
  transform: rotate(-90deg) !important;
}
</style>
